import script from "./AlertsWidget.vue?vue&type=script&lang=ts&setup=true"
export * from "./AlertsWidget.vue?vue&type=script&lang=ts&setup=true"

import "./AlertsWidget.vue?vue&type=style&index=0&id=78e3daf0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78e3daf0"]])

export default __exports__